{
  "register-pin-page": {
    "buttons": {
      "resend": "Erneut senden",
      "submit": "Einreichen"
    },
    "text": {
      "email-check": "TIPPS: Bitte überprüfen Sie auch Ihren Spam-Ordner oder überprüfen Sie, ob Ihre E-Mail <strong>{{ email }}</strong> korrekt ist oder verwenden Sie eine andere E-Mail für die Registrierung!",
      "in-second": "in {{seconds}} s",
      "not-receive-pin": "Sie haben keine PIN erhalten?",
      "pin-incorrect": "Die PIN ist ungültig. Bitte überprüfen Sie sie in Ihrer E-Mail und versuchen Sie es erneut.",
      "verify-account": "Überprüfen Sie Ihr Konto",
      "verify-account-hint": "Der Bestätigungsnummer wird an Ihre E-Mail <strong>{{ email }}</strong> geschickt."
    }
  }
}
